import * as React from "react";
import { LocalizeContextProps, Translate, withLocalize } from "react-localize-redux";
import { Collapse, Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import "./FeatureTable.scss";
import featureTable from "../constants/FeatureTable.json";
import scrollTo from "../helpers/scroll";
import ICatalogItem from "src/models/Catalog";
import Number from "./Number";

type IProps = {
  catalogData: ICatalogItem[];
} & LocalizeContextProps;

interface IState {
  collapseAll: boolean;
  collapseMain: boolean;
  featureCollapse: any;
  productNames: any;
  showSuccessDialog: boolean;
}

class FeatureTable extends React.Component<IProps, IState> {
  private featureTable: any;
  private timeout: NodeJS.Timeout;

  public constructor(props: IProps) {
    super(props);

    this.featureTable = featureTable;

    this.state = {
      collapseAll: false,
      collapseMain: true,
      featureCollapse: this.featureTable.features.reduce((obj: any, feature: any) => {
        obj[feature.name] = false;
        return obj;
      }, {}),
      productNames: {},
      showSuccessDialog: false,
    };

    this.closeFeatureTable = this.closeFeatureTable.bind(this);
    this.collapseFeature = this.collapseFeature.bind(this);
    this.toggleAll = this.toggleAll.bind(this);
    this.toggleAllOnEnter = this.toggleAllOnEnter.bind(this);
    this.toggleFeatureCollapse = this.toggleFeatureCollapse.bind(this);
    this.toggleFeatureOnEnter = this.toggleFeatureOnEnter.bind(this);
    this.toggleMain = this.toggleMain.bind(this);
    this.handleDialogShow = this.handleDialogShow.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
  }

  public render() {
    return (
      <div className="view-prices">
        <div className="package-card card">
          <div className="card-body row">
            <div className="col-12 col-md-6 my-auto">
              <Translate id="ComparePackagesDescr" />
            </div>
            <div className="col-12 col-md-6 text-right">
              <Button tabIndex={0} color="secondary" aria-label="Open" onClick={this.handleDialogShow}><Translate id="ComparePackages" /></Button>
            </div>
          </div>
        </div>
        <Modal size="xl" isOpen={this.state.showSuccessDialog} toggle={this.handleDialogClose} centered={true}>
          <ModalHeader toggle={this.handleDialogClose} />
          <ModalBody>
            <div className="feature-table scroll-packages">
              <div className="row">
                <div className="disclaimer col-12 col-md-8 d-flex flex-wrap p-3 justify-content-start"><h2><Translate id="ComparePackagesModalTitle" /></h2></div>
                <div className="disclaimer col-12 col-md-4 d-flex flex-wrap p-3 justify-content-end">
                  <span>
                    <span className="mx-1 included" />
                    <span className="mx-1">
                      <Translate id="Included" />
                    </span>
                  </span>
                  <span>
                    <span className="mx-1 ml-2 partly included" />
                    <span className="mx-1">
                      <Translate id="IncludedPartly" />
                    </span>
                  </span>
                </div>
              </div>
              <div className="container toggle primary ">
                <div className="row">
                  <a tabIndex={0} className="toggle-title col-4 p-2 d-flex align-items-center" onKeyPress={this.toggleAllOnEnter} onClick={this.toggleAll}>
                    <span className={"d-none d-md-block plusminus " + (this.state.collapseAll ? "opened" : "closed")}>
                      <span className="horizontal" />
                      <span className="vertical" />
                    </span>
                    <span>{this.state.collapseAll ? <Translate id="HideAll" /> : <Translate id="OpenAll" />}</span>
                  </a>
                  <div className="package-name p-1 d-flex align-items-center justify-content-center package-col package-head">{this.state.productNames.basic}</div>
                  <div className="package-name p-1 d-flex align-items-center justify-content-center package-col package-head">{this.state.productNames.starter}</div>
                  <div className="package-name p-1 d-flex align-items-center justify-content-center package-col package-head">{this.state.productNames.core}</div>
                  <div className="package-name p-1 d-flex align-items-center justify-content-center package-col package-head">{this.state.productNames.prof}</div>
                  <div className="package-name p-1 d-flex align-items-center justify-content-center package-col package-head"><Translate id={"NV-nvpalkp.name"} /></div>
                </div>
              </div>
              {this.featureTable.features.map((feature: any, idx: number) => (
                <div key={idx}>
                  <div className={"toggle secondary container " + feature.name}>
                    <div className="row border border-top-0">
                      <a tabIndex={0} className="col-4 p-2 d-flex align-items-center" data-name={feature.name} onKeyPress={this.toggleFeatureOnEnter} onClick={this.toggleFeatureCollapse}>
                        <span className={"d-none d-md-block plusminus " + (this.state.featureCollapse[feature.name] ? "opened" : "closed")}>
                          <span className="horizontal" />
                          <span className="vertical" />
                        </span>
                        <span className="toggle-title">
                          <Translate id={feature.name} />
                        </span>
                      </a>
                      <div className={"feature-status d-flex align-items-center justify-content-center p-1 border-left package-col " + (this.state.featureCollapse[feature.name] ? "invisible" : "")}><span>{this.getFeatureTag(feature["NV-basic"])}</span></div>
                      <div className={"feature-status d-flex align-items-center justify-content-center p-1 border-left package-col " + (this.state.featureCollapse[feature.name] ? "invisible" : "")}><span>{this.getFeatureTag(feature["NV-starter"])}</span></div>
                      <div className={"feature-status d-flex align-items-center justify-content-center p-1 border-left package-col " + (this.state.featureCollapse[feature.name] ? "invisible" : "")}><span>{this.getFeatureTag(feature["NV-core"])}</span></div>
                      <div className={"feature-status d-flex align-items-center justify-content-center p-1 border-left package-col " + (this.state.featureCollapse[feature.name] ? "invisible" : "")}><span>{this.getFeatureTag(feature["NV-prof"])}</span></div>
                      <div className={"feature-status d-flex align-items-center justify-content-center p-1 border-left package-col " + (this.state.featureCollapse[feature.name] ? "invisible" : "")}><span>{this.getFeatureTag(feature["NV-nvpalkp"])}</span></div>
                    </div>
                  </div>
                  <Collapse isOpen={this.state.featureCollapse[feature.name]}>
                    {feature.children.map((childFeature: any, idx2: number) => (
                      <div key={idx2} className={"container "  + childFeature.name + "-collapse"}>
                        <div className="feature-row row border border-top-0">
                          <div className="col-4 p-2 d-flex">
                            <span className="toggle-title ml-2 ml-md-4">
                              <Translate id={childFeature.name} />
                            </span>
                          </div>
                          <div className="feature-status d-flex align-items-center justify-content-center p-1 border-left package-col "><span>{this.getFeatureTag(childFeature["NV-basic"])}</span></div>
                          <div className="feature-status d-flex align-items-center justify-content-center p-1 border-left package-col "><span>{this.getFeatureTag(childFeature["NV-starter"])}</span></div>
                          <div className="feature-status d-flex align-items-center justify-content-center p-1 border-left package-col "><span>{this.getFeatureTag(childFeature["NV-core"])}</span></div>
                          <div className="feature-status d-flex align-items-center justify-content-center p-1 border-left package-col "><span>{this.getFeatureTag(childFeature["NV-prof"])}</span></div>
                          <div className="feature-status d-flex align-items-center justify-content-center p-1 border-left package-col "><span>{this.getFeatureTag(childFeature["NV-nvpalkp"])}</span></div>
                        </div>
                      </div>
                    ))}
                  </Collapse>
                </div>
              ))}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button tabIndex={0} color="secondary" aria-label="Close" onClick={this.handleDialogClose}>
              <Translate id="Close" />
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }

  public componentWillReceiveProps() {
    const basic = this.props.catalogData.find((item: ICatalogItem) => item.sku === "NV-basic");
    const starter = this.props.catalogData.find((item: ICatalogItem) => item.sku === "NV-starter");
    const core = this.props.catalogData.find((item: ICatalogItem) => item.sku === "NV-core");
    const prof = this.props.catalogData.find((item: ICatalogItem) => item.sku === "NV-prof");
    const salary = this.props.catalogData.find((item: ICatalogItem) => item.sku === "NV-nvpalkp");
    this.setState({
      productNames: {
        basic: basic ? basic.name : "",
        core: core ? core.name : "",
        prof: prof ? prof.name : "",
        salary: salary ? salary.name : "",
        starter: starter ? starter.name : ""
      }
    });
  }

  public componentWillUnmount() {
    clearTimeout(this.timeout);
  }
  private handleDialogShow() {
    this.setState({
      showSuccessDialog: true
    });
  }
  private handleDialogClose() {
    this.setState({
      showSuccessDialog: false
    });
  }
  private toggleMain(event?: React.KeyboardEvent<HTMLElement> | React.FormEvent<HTMLElement>) {
    if (event && event.type === "keypress") {
      // tslint:disable-next-line
      if (event["key"] === "Enter" || event["key"] === " ") {
        event.preventDefault();
        this.setState({ collapseMain: !this.state.collapseMain });
      }
    } else {
      this.setState({ collapseMain: !this.state.collapseMain });
    }
  }
  private closeFeatureTable(event?: React.KeyboardEvent<HTMLElement> | React.FormEvent<HTMLElement>) {
    if (event && event.type === "keypress") {
      // tslint:disable-next-line
      if (event["key"] === "Enter" || event["key"] === " ") {
        event.preventDefault();
        scrollTo(document.querySelector(".feature-table")).then(() => {
          this.toggleMain();
        });
      }
    } else {
      scrollTo(document.querySelector(".feature-table")).then(() => {
        this.toggleMain();
      });
    }
  }
  private toggleAllOnEnter(event: React.KeyboardEvent<HTMLElement>) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.toggleAll();
    }
  }
  private toggleAll() {
    const collapseAll = !this.state.collapseAll;
    const featureCollapse = Object.assign({}, this.state.featureCollapse);
    for (const key of Object.keys(featureCollapse)) {
      featureCollapse[key] = collapseAll;
    }
    this.setState({ collapseAll, featureCollapse });
  }
  private toggleFeatureOnEnter(event: React.KeyboardEvent<HTMLElement>) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.collapseFeature(event.currentTarget.dataset && event.currentTarget.dataset.name);
    }
  }
  private toggleFeatureCollapse(event: React.FormEvent<HTMLElement>) {
    this.collapseFeature(event.currentTarget.dataset && event.currentTarget.dataset.name);
  }
  private collapseFeature(name: string | undefined) {
    const featureCollapse = Object.assign({}, this.state.featureCollapse);
    const features = Object.keys(featureCollapse);
    let collapsed = 0;
    for (const key of features) {
      if (key === name) {
        featureCollapse[key] = !featureCollapse[key];
      }
      if (featureCollapse[key]) {
        collapsed++;
      }
    }

    // Check if all or none are collapsed
    if (collapsed === features.length) {
      this.setState({ collapseAll: true });
    } else if (collapsed === 0) {
      this.setState({ collapseAll: false });
    }

    this.setState({ featureCollapse });
  }

  private getFeatureTag(featureStatus: any) {
    if (featureStatus === 0) {
      return <div className="not-included" />;
    } else if (featureStatus === 1) {
      return <div className="partly included" />;
    } else if (featureStatus === 2) {
      return <div className="included" />;
    } else if (featureStatus === "ExtraService") {
      return <Translate id="ExtraService" />;
    } else if (featureStatus === "SalarySlip") {
      return <Translate id="SalarySlip" />;
    } else if (featureStatus === "Euro") {
      return <div>€</div>;
    } else if (typeof featureStatus === "object" && featureStatus.price) {
      return (
        <div>
          <Number value={featureStatus.price} /> <Translate id={featureStatus.unit} />
        </div>
      );
    }
    return null;
  }
}

export default withLocalize<IProps>(FeatureTable);
